// import { RGBELoader } from 'three/addons/loaders/RGBELoader.js';
import { AmbientLight, Scene } from 'three';
import { DirectionalLight, HemisphereLight, PointLight } from "three";
import type ThreeJSApp from "../../app";
import Renderer from "../renderer/renderer";
import { defaultLightingConfig } from '../../config/default.config';
import type { LightingConfig } from "./type";
import { createEnvironmentFromConfig, createLightsFromConfigAndRender } from './core';
import { cleanupLights, cleanupEnvironment } from './util';

export default class Light {
  root: ThreeJSApp;
  renderer: Renderer;
  scene: Scene;
  lights: (DirectionalLight | HemisphereLight | PointLight | AmbientLight)[] = [];
  private lightingConfig: LightingConfig;

  constructor(root: ThreeJSApp) {
    this.root = root;
    this.renderer = this.root.renderer;
    this.scene = this.root.scene;
    this.lightingConfig = defaultLightingConfig;
    this.setEnvironment();
    this.setLights();
  }

  //Config가 공통적으로 들어가는게 나을지도 모르겠음.
  setLights() {
    this.lights = createLightsFromConfigAndRender(this.lightingConfig, this.scene);
  }

  setEnvironment() {
    createEnvironmentFromConfig(this.lightingConfig, this.scene, this.renderer);
  }

  // 조명 설정 동적 업데이트
  updateConfig(newConfig: LightingConfig) {
    

    // 기존 조명 및 환경맵 정리
    cleanupLights(this.lights, this.scene);
    cleanupEnvironment(this.scene);
    this.lights = [];

    // 새로운 설정 적용
    this.lightingConfig = newConfig;

    // 새로운 조명 및 환경맵 생성
    this.setEnvironment();
    this.setLights();

    
  }

  destroy() {
    // 라이트들 정리
    cleanupLights(this.lights, this.scene);
    this.lights = [];

    // 환경맵 정리
    cleanupEnvironment(this.scene);
  }
}